<div class="c-product row">
    <div class="col-9 p-0">
        <div class="titulo-producto">
            {{product.title}}
        </div>
        <!-- <ng-container *ngIf="esProductoEnVenta; else equipoEnArriendo">
            <div class="c-contenedor-tipoV">
            <div class="c-text-sub-a"> Equipo en Venta</div>
            </div>
        </ng-container>
        <ng-template #equipoEnArriendo>
            <div class="c-contenedor-tipoA">
                <div class="c-text-sub"> Equipo en Arriendo</div> 
            </div>
        </ng-template> -->
    </div>
    <div class="col-3 p-0  align-self-end" (click)="toggle()" *ngIf="!bloquearCantidad">
        <img *ngIf="!isClicked" class="icn-arrow-down c-mover-derecha" src="./assets/icons/icon-arrow-down.svg" alt="">
        <img *ngIf="isClicked" class="icn-arrow-down c-mover-derecha" src="assets/icons/icon-arrow-up.svg" alt="">
    </div>

    <ng-container *ngIf="product.isOpen">
        <div class="col-12 c-product-detail">
            <div class="row mt-36">
                <div class="col-6 p-0">
                    <div class="c-texto__carro--producto">Tipo de venta</div>
                </div>
                <div class="col-6  p-0 c-texto__carro--valor tex-al-right"> {{ product.tipoVenta | tipoVenta }} </div>
            </div>
            <div class="row mt-27">
                <div class="col-6  p-0">
                    <div class="c-texto__carro--producto">Producto</div>
                </div>
                <div class="col-6  p-0 c-texto__carro--valor tex-al-right"> Webpay PLUS  </div>
            </div>

            <div class="row">
                <div class="col align-self-start">
                </div>
                <div class="col align-self-end jus-right">
                    <i class="icon-eliminar c-mover-derecha" (click)="deleteProduct()" *ngIf="!bloquearCantidad"></i>
                </div>
            </div>
        </div>
    </ng-container>
    <div *ngIf="container" class="conteiner-blanco"></div>

    <ng-container *ngIf="desplegarValores">
        <div class="col-5 p-0 p ">
              <div [ngClass]="{'mt-42':distanciaOk,'mt-48':!distanciaOk}" class="c-texto__carro--valor-a   ">Plan anual:
              </div>
          </div>
          <div class="col-7 p-0">
            <div [ngClass]="{'mt-42':distanciaOk,'mt-48':!distanciaOk}" class="c-texto-valor-neto"><strong>${{
              valorProductoPeso | thousandsPipe }}</strong><br>valor aprox. con IVA</div>
          </div>
          <div class="col-4 p-0"></div>
          <div class="col-8 p-0">
            <div class="c-texto-valor-peso">Equivalente a: {{(amountUf | changedot)}} UF + IVA</div>
          </div>

    </ng-container>
    
</div>